import type { ReactNode } from 'react';
import type { NiveauAlerte } from '@dinertournant/core';
import { IconeActualiser, IconeAttention, IconeCoche, IconeInfo } from './icones.js';

interface Props {
  niveau: NiveauAlerte | 'sombre';
  /** Début en gras (« Personne n'a coché le dessert. »). */
  titre?: ReactNode;
  children?: ReactNode;
  /** Boutons d'action : une alerte informe sans bloquer et propose toujours une action. */
  actions?: ReactNode;
  role?: 'alert' | 'status';
}

/** Bandeau d'alerte : ocre pour ce qui mérite attention, bleu pour ce qui s'explique, jamais de rouge. */
export function BandeauAlerte({ niveau, titre, children, actions, role = 'status' }: Props) {
  const icone = niveau === 'attention' ? <IconeAttention /> : niveau === 'ok' ? <IconeCoche /> : niveau === 'sombre' ? <IconeActualiser /> : <IconeInfo />;
  return (
    <div className={`alerte ${niveau}`} role={role}>
      <span className="icone">{icone}</span>
      <div className="corps">
        <div>
          {titre ? <strong>{titre} </strong> : null}
          {children}
        </div>
        {actions ? <div className="actions">{actions}</div> : null}
      </div>
    </div>
  );
}
